<template>
  <v-icon
    v-if="isShowingInstructionIcons"
    class="mx-2"
    @mouseenter="$emit('input', true)"
    @mouseleave="$emit('input', false)"
    >{{ icon.instruction }}</v-icon
  >
</template>

<script>
import { mdiHelpCircleOutline } from "@mdi/js";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState(["isShowingInstructionIcons"])
  },
  data: () => ({
    icon: {
      instruction: mdiHelpCircleOutline
    }
  })
};
</script>
